module.exports = __webpack_public_path__ + "static/media/cbsc2020.9f9639ac.jpg";